export const appConfig = {
  // Control de estado para el boton de adjuntar
  showAttachButton: false,
  // Variable para el título del encabezado
  headerTitle: 'Assistant AI',
};